// extracted by mini-css-extract-plugin
export var fadeInAnimation = "TopProjects-module--fadeInAnimation--5c9f6";
export var slider = "TopProjects-module--slider--bbef8";